<div *ngIf="widgetTitle" class="widget__header">
    <h4>{{ widgetTitle }}</h4>
</div>
<ul class="widget-posts__list">
    <li *ngFor="let post of posts" class="widget-posts__item">
        <div class="widget-posts__image">
            <a href="">
                <img [src]="post.image" alt="">
            </a>
        </div>
        <div class="widget-posts__info">
            <div class="widget-posts__name">
                <a href="">{{ post.title }}</a>
            </div>
            <div class="widget-posts__date">{{ post.date }}</div>
        </div>
    </li>
</ul>
